exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progressbar-outer {\n  width: 100px;\n  height: 100px;\n  padding: 8px;\n  background-color: rgba(0, 0, 0, 0.87);\n  border: 10px #dcdcdc;\n  color: #fff;\n  border-radius: 50px;\n  text-align: center;\n  border-style: none;\n  left: 40%;\n  top: 220px;\n  position: absolute; }\n\n.progressbar-inner {\n  min-width: 15%;\n  white-space: nowrap;\n  overflow: hidden;\n  padding: 30px;\n  border-radius: 20px; }\n\n.main_outer {\n  top: 70px;\n  display: block;\n  position: fixed;\n  z-index: 10000;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: black;\n  background-color: rgba(0, 0, 0, 0.4); }\n\n.description {\n  text-align: center;\n  /* background: #035168 !important; */\n  color: #e60e68 !important;\n  font-size: 12px;\n  padding: 10px; }\n\n.title {\n  text-align: center;\n  background: #035168 !important;\n  color: #fafafa !important;\n  font-size: 12px;\n  padding: 10px; }\n\n.loader-content {\n  top: 30% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1077032063/src/src/app/generic-ui-components/data-processing-status/data-processing-status.component.scss
// module id = ../../../../../src/app/generic-ui-components/data-processing-status/data-processing-status.component.scss
// module chunks = main